import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { NavsearchComponent } from './header/navsearch/navsearch.component';
import { OffsidebarComponent } from './offsidebar/offsidebar.component';
import { UserblockComponent } from './sidebar/userblock/userblock.component';
import { UserblockService } from './sidebar/userblock/userblock.service';
import { FooterComponent } from './footer/footer.component';

import { SharedModule } from '../shared/shared.module';
import { SubscriberSidebarComponent } from './subscriber-sidebar/subscriber-sidebar.component';
import { SubscriberHeaderComponent } from './subscriber-header/subscriber-header.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ConfirmDialogModule } from '../adminUsers/confirm-dialog/confirm-dialog.module';
import { ApplicantSidebarComponent } from './applicant-sidebar/applicant-sidebar.component';
import { ApplicantHeaderComponent } from './applicant-header/applicant-header.component';
import { GlobalSearchComponent } from './global-search/global-search.component';
import { EveeAssistantComponent } from '../shared/evee-assistant/evee-assistant.component';
import { LiveNotificationsComponent } from './live-notifications/live-notifications.component';

@NgModule({
    imports: [
        SharedModule,
        Ng2SearchPipeModule,
        ConfirmDialogModule,
    ],
    providers: [
        UserblockService
    ],
    declarations: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        OffsidebarComponent,
        FooterComponent,
        SubscriberSidebarComponent,
        SubscriberHeaderComponent,
        ApplicantSidebarComponent,
        ApplicantHeaderComponent,
        GlobalSearchComponent,
        EveeAssistantComponent,
        LiveNotificationsComponent
    ],
    exports: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        OffsidebarComponent,
        FooterComponent,
        GlobalSearchComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
})
export class LayoutModule { }
